import { useMemo } from "react"
import { TextField, TextFieldProps } from "@mui/material"

import { MAX_TEXT_FIELD_LENGTH } from "../../../constants/inputValidationDefaults"

type StandardTextFieldProps = Readonly<
    TextFieldProps & {
        maxLength?: number
    }
>

export function StandardTextField({
    maxLength = MAX_TEXT_FIELD_LENGTH,
    inputProps,
    type,
    ...rest
}: StandardTextFieldProps) {
    const mergedInputProps = useMemo(
        () => ({
            ...(type !== "number" ? { maxLength } : undefined),
            ...inputProps,
        }),
        [maxLength, inputProps, type],
    )

    return <TextField type={type} inputProps={mergedInputProps} {...rest} />
}

